import { BusinessProfileUIState } from './BusinessProfile.data';

export const validateBusinessProfile = (data: BusinessProfileUIState): { isValid: boolean; errors: string[] } => {
    const errors: string[] = [];

    if (!data.business_name || data.business_name.trim().length === 0) {
        errors.push('Business name is required');
    }

    if (!data.business_category || data.business_category.trim().length === 0) {
        errors.push('Business category is required');
    }

    if (data.business_url && !isValidUrl(data.business_url)) {
        errors.push('Business URL must be a valid URL');
    }

    if (data.logo_file && data.logo_file.size > 2 * 1024 * 1024) {
        errors.push('Logo size must be less than 2MB');
    }

    if (data.logo_file && !isValidImageFormat(data.logo_file)) {
        errors.push('Logo must be JPG, PNG or GIF format');
    }

    return {
        isValid: errors.length === 0,
        errors,
    };
};

export const isValidUrl = (url: string): boolean => {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
};

export const isValidImageFormat = (file: File): boolean => {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    return validTypes.includes(file.type);
};

export const formatTimeForDisplay = (time: string): string => {
    if (!time) return '--:--';
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;
};

export const formatTimeForInput = (time: string): string => {
    if (!time) return '';
    return time;
};

